import Box from 'carbon-react/esm/components/box';
import Typography from 'carbon-react/esm/components/typography';
import React from 'react';
import { Link } from 'react-router-dom';
import { ENV } from '../config/env';

const DebugInfos: React.FC = () => {
  // const { hasRole, handleLogout } = useUserInfos();

  return (
    <Box
      height="700px"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      gap={2}
    >
      <Typography variant="h1" mb={2}>
        Debug Infos
      </Typography>

      {process.env.NODE_ENV === 'development' || (
        <Box as="pre" overflow="auto" mt="10px">
          <Typography as="code" variant="small" size="M" whiteSpace="pre-wrap">
            process.env.NODE_ENV: {process.env.NODE_ENV}
          </Typography>
        </Box>
      )}
      <Box as="pre" overflow="auto" mt="10px">
        <Typography as="code" variant="small" size="M" whiteSpace="pre-wrap">
          process.env.NODE_ENV: {process.env.NODE_ENV}
          {'\n'}
          Plateforme: {ENV.APP_ENV}
          {'\n'}
          ENV - Back: {ENV.BACK_EDI_URL}
          {'\n'}
          VITE - Back: {import.meta.env.VITE_BACK_EDI_URL}
          {'\n'}
          VITE - Back Proxy: {import.meta.env.VITE_BACK_EDI_PROXY_URL}
          {'\n'}
          CloudId: {import.meta.env.VITE_CLOUDID_DOMAIN} - {import.meta.env.VITE_CLOUDID_AUDIENCE}
        </Typography>
      </Box>

      <Link to="/">Retour à l&apos;accueil</Link>
    </Box>
  );
};

export default DebugInfos;
